/* eslint-disable @typescript-eslint/no-explicit-any */
import {Component, Vue, Watch} from "vue-property-decorator";

import {
    getCompanyList,
    getFinanceContractInfoById, getFinanceContractTemplateById,
    getProjectAllSouCoursePriceList, setFinanceContractTemplate
} from '@/api/financial-center'

import {menuBtn} from '@/utils/menu_level2_button'

import {delNullProperty} from "@/utils";

import E from "wangeditor"
import commonData from "@/utils/commonData";

@Component({})
export default class ContractTemplateInfo extends Vue {
    limit = 20
    tableKey = Math.random()

    formData = {
        detail: '',
        souCourseTypeId: '',
        souCoursePrice: '',
        dissertationType: '',
        companyName: '',
        name: '',
    }

    companyList = []

    disabledButton = false
    saveDraftDialogShow = false
    //
    // isDraft = '0'
    // draftId: number = null // 草稿id

    formRule = {}

    contractTemplateId = null
    isReplace = null


    previewName = ''
    previewVisible = false
    previewPath = ''
    directorUserId = ''


    editor: any = null
    typeList = commonData.projectTypeArray
    souCoursePriceList = []
    contractTemplateInfo = {}
    souCourseType = '' // 项目类型
    loading = false

    // get baseUrl() {
    //     let str = '/fileApi/eqianbao/uploadFile'
    //     if (process.env.NODE_ENV !== "development") {
    //         if (window.location.origin.includes('-testserver')) {
    //             str = process.env.VUE_APP_DEV_FILE_API + 'eqianbao/uploadFile'
    //         } else {
    //             str = process.env.VUE_APP_MASTER_FILE_API + 'eqianbao/uploadFile'
    //         }
    //     }
    //     return str
    // }

    created() {
        if (this.$route.query.contractTemplateId) {
            this.contractTemplateId = Number(this.$route.query.contractTemplateId)
            this.getFinanceContractTemplateById()
        }

        this.getCompanyList()

    }

    menuBtn = menuBtn

    mounted() {
        this.initEditor()
    }

    // 初始化富文本编辑器
    initEditor() {
        //   console.log(E)
        this.editor = new E('#div1')
        this.editor.config.height = 200
        this.editor.config.excludeMenus = [
            'fontName',
            'foreColor',
            'backColor',
            'link',
            'code',
            'splitLine',
            'undo',
            'redo'
        ]
        // this.editor.config.uploadImgServer = 'http://192.168.1.71:10068/uploadFile'
        // this.editor.create()
        this.editor.config.uploadImgShowBase64 = true // 使用 base64 保存图片
        // 隐藏“网络图片”tab
        this.editor.config.showLinkImg = false
        // 创建编辑器
        this.editor.create()
    }

    async changeSouCourseType(val) {

        const data: any = await getProjectAllSouCoursePriceList({
            souCourseTypeId: val
        })
        this.souCoursePriceList = data.souCoursePriceList
    }


    async getFinanceContractTemplateById() {
        this.isReplace = true
        this.loading = true
        await getFinanceContractTemplateById(delNullProperty({
            id: this.contractTemplateId,
        })).then((data: any)=>{
        const {financeContractTemplate} = data
        this.contractTemplateInfo = financeContractTemplate
            //     恢复Tag标签
            let str = financeContractTemplate.detail.replace('{{优惠金额}}', '<input type="button" value="优惠金额" style="border-width: 1px; border-style: solid; border-color: rgb(217, 236, 255); border-radius: 5px; padding-right: 5px; padding-left: 5px; background: rgb(237, 245, 255); color: rgb(70, 159, 255); height: 24px; line-height: 24px;"/>')
            str = str.replace('{{项目金额}}', '<input type="button" value="项目金额" style="border-width: 1px; border-style: solid; border-color: rgb(217, 236, 255); border-radius: 5px; padding-right: 5px; padding-left: 5px; background: rgb(237, 245, 255); color: rgb(70, 159, 255); height: 24px; line-height: 24px;"/>')
            str = str.replace('{{备注}}', '<input type="button" value="备注" style="border-width: 1px; border-style: solid; border-color: rgb(217, 236, 255); border-radius: 5px; padding-right: 5px; padding-left: 5px; background: rgb(237, 245, 255); color: rgb(70, 159, 255); height: 24px; line-height: 24px;"/>')
            str = str.replace('{{收款账户}}','<input type="button" value="收款账户" style="border-width: 1px; border-style: solid; border-color: rgb(217, 236, 255); border-radius: 5px; padding-right: 5px; padding-left: 5px; background: rgb(237, 245, 255); color: rgb(70, 159, 255); height: 24px; line-height: 24px;"/>')

            this.$set(this.contractTemplateInfo, 'detail', str)

        this.typeList.forEach(item => {
            if (financeContractTemplate.souCourseTypeId == item.value) {
                this.souCourseType = item.label
            }
        })
        this.loading = false
        }).catch(err=>{
            this.loading = false
        })

    }





    /*保存*/
    clickSubmintButton() {
        // 校验
        this.formData.detail = this.editor.txt.html()

        const obj = {
            detail: this.formData.detail,
            souCourseTypeId: this.formData.souCourseTypeId,
            souCoursePrice: this.formData.souCoursePrice,
            dissertationType: this.formData.dissertationType,
            companyName: this.formData.companyName,
            name: this.formData.name,
        };
        if (!this.formData.souCourseTypeId) {
            this.$message.error('请选择项目类型')
            return;
        }
        if (!this.formData.souCoursePrice) {
            this.$message.error('请选择项目价格')
            return;
        }
        if (!this.formData.dissertationType) {
            this.$message.error('请选择论文服务类型')
            return;
        }
        if (!this.formData.companyName) {
            this.$message.error('请选择所属公司')
            return;
        }
        if (!this.formData.name) {
            this.$message.error('请填写模板名称')
            return;
        }
        if (!this.formData.detail) {
            this.$message.error('请上传合同')
            return;
        }


        this.disabledButton = true;
        setFinanceContractTemplate(delNullProperty(obj)).then((data) => {
            this.$message.success(`新建成功`)
            this.saveDraftDialogShow = false
            setTimeout(() => {
                this.closePage()
            }, 1500)
        }).catch((err: Error) => {
            if (err) {
                this.disabledButton = false
            }
        })

    }


    /*编辑保存*/
    clickEditSubmitButton() {
        const obj = {
            detail: this.formData.detail,
            souCourseTypeId: this.formData.souCourseTypeId,
            souCoursePrice: this.formData.souCoursePrice,
            dissertationType: this.formData.dissertationType,
            companyName: this.formData.companyName,
            name: this.formData.name,
        };
        if (!this.formData.souCourseTypeId) {
            this.$message.error('请选择项目类型')
            return;
        }
        if (!this.formData.souCoursePrice) {
            this.$message.error('请选择项目价格')
            return;
        }
        if (!this.formData.dissertationType) {
            this.$message.error('请选择论文服务类型')
            return;
        }
        if (!this.formData.companyName) {
            this.$message.error('请选择所属公司')
            return;
        }
        if (!this.formData.name) {
            this.$message.error('请填写模板名称')
            return;
        }
        if (!this.formData.detail) {
            this.$message.error('请上传合同')
            return;
        }
        this.disabledButton = true
        setFinanceContractTemplate(delNullProperty(obj)).then(res => {
            this.$message.success('保存成功，页面即将关闭')
            setTimeout(() => {
                this.closePage()
            }, 1500)
        }).catch(err => {
            this.disabledButton = false
        })
    }


    closePage() {
        window.close()
    }


    // 所属公司列表
    async getCompanyList() {
        const data: any = await getCompanyList()
        this.companyList = data.companyList
    }




}
